// @ts-nocheck
/**
 * One-step onboarding for Admin+ Products & Memberships when opened with ?tour=true.
 * @param {object} vm - Vue component instance with $t
 */
export function buildProductsMembershipsTourSteps(vm) {
  const t = (key) => vm.$t(key);
  return [
    {
      target: '[data-v-step="4"]',
      icon: require("@/assets/icons/admin+/academy_products.svg"),
      label: t("message.onboarding_products_label"),
      title: t("message.onboarding_products_title"),
      autoClick: false,
      description: t("message.onboarding_products_description"),
      before() {
        const element = document.querySelector('[data-v-step="4"]');
        if (element) {
          element.click();
        }
      },
      params: {
        placement: "left",
        highlight: true,
      },
    },
  ];
}
